import { useEffect, useState } from 'react'
import { Input } from 'entities/Input'
import moment, { Moment } from 'moment'
import Accordion from 'entities/Accordion'
import { RenderIf } from 'shared/helpers/renderIf'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'
import { useGlobalStore } from 'shared/store/globalSlice'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'
import { TimeField } from '@mui/x-date-pickers/TimeField'
import { MOMENT_FORMAT_TIME } from 'shared/globalConsts'

export const LeadTime = () => {
  const isCC = useGlobalStore().isCCSelected
  const updateCCConfig = usePaymentConfigStore().updateCCConfig
  const clickCollectConfig = usePaymentConfigStore().clickCollectConfig

  const [daysValue, setDaysValue] = useState('')
  const [timeValue, setTimeValue] = useState('')

  useEffect(() => {
    setDaysValue(prevValue => clickCollectConfig?.leadTimeDays || prevValue)
    setTimeValue(prevValue => clickCollectConfig?.leadTimeHours || prevValue)
  }, [clickCollectConfig])

  const handleDaysBlur = () => {
    if (daysValue !== clickCollectConfig?.leadTimeDays) {
      updateCCConfig({ leadTimeDays: daysValue })
    }
  }

  const handleTimeBlur = () => {
    if (timeValue !== clickCollectConfig?.leadTimeHours) {
      updateCCConfig({ leadTimeHours: timeValue })
    }
  }

  const handleTimeChange = (value: Moment | null) => {
    if (value) {
      setTimeValue(value.format(MOMENT_FORMAT_TIME))
    }
  }

  return (
    <>
      <RenderIf condition={isCC}>
        <Accordion title='Options'>
          <TwoColumnedDiv>
            <Input
              fullWidth
              label='Lead time in days'
              type='number'
              value={daysValue}
              onChange={setDaysValue}
              onBlur={handleDaysBlur}
            />
            <TimeField
              fullWidth
              label='Lead time in hours'
              value={moment().set({
                hour: Number(timeValue?.split(':')?.[0]),
                minute: Number(timeValue?.split(':')?.[1])
              })}
              onChange={handleTimeChange}
              onBlur={handleTimeBlur}
              format='HH:mm'
            />
          </TwoColumnedDiv>
        </Accordion>
      </RenderIf>
    </>
  )
}
